export const CASUAL_PAGE_CONFIG = {
  "title": "Daily-IAA Game",
  "titleCN": "日报-休闲游戏",
  "path": "/overview/daily",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "isHaveNotification": true,
      "notificationPath": "/overview/daily",
      "path": "/overview/daily",
      "logConfig": {
        "pageId": "200102",
        "pageName": "Daily-IAA Game",
        "extInfo": "overviewDaily-IAA",
        "pagePath": "/overview/daily"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/daily",
          "extraFilterList": [
            "ad_format"
          ],
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "Service",
                  "props": {
                    "api": "/api/v2/dashboard/benchmark/metric",
                    "dataKey": "keyMetricBenchmarkData",
                    "trackData": [],
                    "beforeRequest": "function() {\n                      return {\n                        filters: {\n                          genre_list: [],\n                          game_list: []\n                        },\n                        frame_type: 'Mobile',\n                        has_game_contributors: false,\n                        metrics: [\n                          'arpdau_android',\n                          'arpdau_ios',\n                          'impdau_android',\n                          'impdau_ios',\n                          'ecpm_android_general',\n                          'ecpm_ios_general',\n                          'd1ret_android',\n                          'd1ret_ios',\n                          'd7ret_android',\n                          'd7ret_ios',\n                          'd28ret_android',\n                          'd28ret_ios',\n                          'cpi_android',\n                          'cpi_ios',\n                          'ctr_iaa'\n                        ]\n                      };\n                    }"
                  },
                  "children": [
                    {
                      "name": "KeyMetricTitle",
                      "props": {
                        "config": {
                          "rightSlot": {
                            "name": "VsBenchmarkBtn",
                            "props": {
                              "hasVs": true,
                              "benchmarkConfig": {
                                "textEn": "Benchmark",
                                "textCn": "Benchmark",
                                "bubblePlacement": "left",
                                "bubbleDark": true,
                                "trackingConfig": {
                                  "enabled": true,
                                  "interval": 3000
                                },
                                "logConfig": {
                                  "buttonId": "200102901",
                                  "extInfo": "Benchmark (Median)"
                                }
                              },
                              "bubbleSlot": {
                                "name": "KeyMetricBenchmarkPanel",
                                "props": {
                                  "dataKey": "keyMetricBenchmarkData",
                                  "titleEn": "Benchmark (Median)",
                                  "titleCn": "行业基准 (中位数)",
                                  "jumpUrl": "/v2/benchmark/mobile/explore?category=IAA",
                                  "footerConfig": {
                                    "disclaimerEn": "*The metrics are calculated by DataBrain based on data from AppLovin and Google, as well as reports published by external industry sources or third-party data providers. United States data only.",
                                    "disclaimerCn": "*指标由DataBrain根据AppLovin和Google数据，及外部行业报告或三方数据源公布的报告进行统计计算。仅限美国数据。",
                                    "contactPrefixEn": "*For any questions, contact ",
                                    "contactPrefixCn": "*如有问题，请联系 ",
                                    "contactEmail": "yanxingqi@tencent.com"
                                  },
                                  "sections": [
                                    {
                                      "columns": [
                                        {
                                          "key": "metric",
                                          "titleEn": "Sales Metrics",
                                          "titleCn": "卖量指标",
                                          "align": "left",
                                          "enWidth": 100,
                                          "cnWidth": 80
                                        },
                                        {
                                          "key": "android",
                                          "titleEn": "Android",
                                          "titleCn": "安卓",
                                          "align": "right",
                                          "width": 80
                                        },
                                        {
                                          "key": "ios",
                                          "titleEn": "iOS",
                                          "titleCn": "iOS",
                                          "align": "right",
                                          "width": 80
                                        }
                                      ],
                                      "metrics": [
                                        {
                                          "nameEn": "{{metricsInfo.imps_per_dau.en}}",
                                          "nameCn": "{{metricsInfo.imps_per_dau.cn}}",
                                          "valueKeys": {
                                            "android": "impdau_android",
                                            "ios": "impdau_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        },
                                        {
                                          "nameEn": "{{metricsInfo.ecpm.en}}",
                                          "nameCn": "{{metricsInfo.ecpm.cn}}",
                                          "valueKeys": {
                                            "android": "ecpm_android_general",
                                            "ios": "ecpm_ios_general"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        },
                                        {
                                          "nameEn": "{{metricsInfo.arpu.en}}",
                                          "nameCn": "{{metricsInfo.arpu.cn}}",
                                          "valueKeys": {
                                            "android": "arpdau_android",
                                            "ios": "arpdau_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        }
                                      ]
                                    },
                                    {
                                      "columns": [
                                        {
                                          "key": "metric",
                                          "titleEn": "Active Metrics",
                                          "titleCn": "活跃指标",
                                          "align": "left",
                                          "enWidth": 100,
                                          "cnWidth": 80
                                        },
                                        {
                                          "key": "android",
                                          "titleEn": "Android",
                                          "titleCn": "安卓",
                                          "align": "right",
                                          "width": 80
                                        },
                                        {
                                          "key": "ios",
                                          "titleEn": "iOS",
                                          "titleCn": "iOS",
                                          "align": "right",
                                          "width": 80
                                        }
                                      ],
                                      "metrics": [
                                        {
                                          "nameEn": "{{metricsInfo.d1.en}}",
                                          "nameCn": "{{metricsInfo.d1.cn}}",
                                          "valueKeys": {
                                            "android": "d1ret_android",
                                            "ios": "d1ret_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        },
                                        {
                                          "nameEn": "{{metricsInfo.d7.en}}",
                                          "nameCn": "{{metricsInfo.d7.cn}}",
                                          "valueKeys": {
                                            "android": "d7ret_android",
                                            "ios": "d7ret_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        },
                                        {
                                          "nameEn": "{{metricsInfo.d28.en}}",
                                          "nameCn": "{{metricsInfo.d28.cn}}",
                                          "valueKeys": {
                                            "android": "d28ret_android",
                                            "ios": "d28ret_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        }
                                      ]
                                    },
                                    {
                                      "columns": [
                                        {
                                          "key": "metric",
                                          "titleEn": "Buying Metrics",
                                          "titleCn": "买量指标",
                                          "align": "left",
                                          "enWidth": 120,
                                          "cnWidth": 80
                                        },
                                        {
                                          "key": "android",
                                          "titleEn": "Android",
                                          "titleCn": "安卓",
                                          "align": "right",
                                          "width": 70
                                        },
                                        {
                                          "key": "ios",
                                          "titleEn": "iOS",
                                          "titleCn": "iOS",
                                          "align": "right",
                                          "width": 60
                                        }
                                      ],
                                      "metrics": [
                                        {
                                          "nameEn": "{{metricsInfo.cpi.en}}",
                                          "nameCn": "{{metricsInfo.cpi.cn}}",
                                          "valueKeys": {
                                            "android": "cpi_android",
                                            "ios": "cpi_ios"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        },
                                        {
                                          "nameEn": "{{metricsInfo.ctr.en}}",
                                          "nameCn": "{{metricsInfo.ctr.cn}}",
                                          "valueKeys": {
                                            "android": "ctr_iaa",
                                            "ios": "ctr_iaa"
                                          },
                                          "valuePath": "{{text_value_json.median_text}}"
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "PlatformMetricsCo",
                  "className": "margin-t-10",
                  "type": "view",
                  "props": {
                    "customRender": true,
                    "dataKey": "iaaRevenueDimensionData",
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                      "metricsList": [
                        "iaa_revenue"
                      ],
                      "serviceParams": {
                        "breakdown_dimension": "ad_format",
                        "logical_flag": "top_no_others"
                      },
                      "otherParams": "function(data) {\n                                                var existingCustomFilters = data && data.custom_filters || [];\n                                                var adFormatFilter = existingCustomFilters.find(function(item) {\n                                                    return item.key === 'ad_format';\n                                                });\n                                                if (adFormatFilter) {\n                                                    adFormatFilter.filter_list = [\n                                                        'interstitial',\n                                                        'banner',\n                                                        'rewarded'\n                                                    ];\n                                                } else {\n                                                    existingCustomFilters.push({\n                                                        key: 'ad_format',\n                                                        filter_list: [\n                                                            'interstitial',\n                                                            'banner',\n                                                            'rewarded'\n                                                        ]\n                                                    });\n                                                }\n                                                return {\n                                                    filters: Object.assign({}, data, {\n                                                        custom_filters: existingCustomFilters\n                                                    })\n                                                };\n                                            }"
                    }
                  },
                  "children": [
                    {
                      "name": "PlatformMetricsCo",
                      "className": "margin-t-10",
                      "type": "view",
                      "props": {
                        "customRender": true,
                        "dataKey": "impressionDimensionData",
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                          "metricsList": [
                            "imps_per_dau"
                          ],
                          "serviceParams": {
                            "breakdown_dimension": "ad_format",
                            "logical_flag": "top_no_others"
                          },
                          "otherParams": "function(data) {\n                                                        var existingCustomFilters = data && data.custom_filters || [];\n                                                        var adFormatFilter = existingCustomFilters.find(function(item) {\n                                                            return item.key === 'ad_format';\n                                                        });\n                                                        if (adFormatFilter) {\n                                                            adFormatFilter.filter_list = [\n                                                                'interstitial',\n                                                                'banner',\n                                                                'rewarded'\n                                                            ];\n                                                        } else {\n                                                            existingCustomFilters.push({\n                                                                key: 'ad_format',\n                                                                filter_list: [\n                                                                    'interstitial',\n                                                                    'banner',\n                                                                    'rewarded'\n                                                                ]\n                                                            });\n                                                        }\n                                                        return {\n                                                            filters: Object.assign({}, data, {\n                                                                custom_filters: existingCustomFilters\n                                                            })\n                                                        };\n                                                    }"
                        }
                      },
                      "children": [
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "customRender": true,
                            "dataKey": "ecpmDimensionData",
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "ecpm"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format",
                                "logical_flag": "top_no_others"
                              },
                              "otherParams": "function(data) {\n                                                                var existingCustomFilters = data && data.custom_filters || [];\n                                                                var adFormatFilter = existingCustomFilters.find(function(item) {\n                                                                    return item.key === 'ad_format';\n                                                                });\n                                                                if (adFormatFilter) {\n                                                                    adFormatFilter.filter_list = [\n                                                                        'interstitial',\n                                                                        'banner',\n                                                                        'rewarded'\n                                                                    ];\n                                                                } else {\n                                                                    existingCustomFilters.push({\n                                                                        key: 'ad_format',\n                                                                        filter_list: [\n                                                                            'interstitial',\n                                                                            'banner',\n                                                                            'rewarded'\n                                                                        ]\n                                                                    });\n                                                                }\n                                                                return {\n                                                                    filters: Object.assign({}, data, {\n                                                                        custom_filters: existingCustomFilters\n                                                                    })\n                                                                };\n                                                            }"
                            }
                          },
                          "children": [
                            {
                              "name": "ServiceSelectorFormat",
                              "props": {
                                "fieldMappings": [
                                  {
                                    "filterPath": "custom_filters.ua_network",
                                    "selectorPath": "ua_network",
                                    "cascadeConfig": {
                                      "typeField": "type",
                                      "typeValue": "UA",
                                      "codeField": "code",
                                      "filterByType": true
                                    }
                                  }
                                ]
                              },
                              "children": [
                                {
                                  "name": "Service",
                                  "className": "",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                    "trackData": [
                                      "extraParams",
                                      "gameCode",
                                      "formattedFilter",
                                      "is_confirm"
                                    ],
                                    "dataKey": "cvrKeyMetricsData",
                                    "beforeRequest": "function(data) {\n                                                                            var gameCode = data.gameCode, formattedFilter = data.formattedFilter, filterVal = data.filterVal, is_confirm = data.is_confirm;\n                                                                            var rangeTime = filterVal.rangeTime;\n                                                                            return {\n                                                                                game_code: gameCode,\n                                                                                filters: formattedFilter,\n                                                                                metrics: [\n                                                                                    \"ug_cvr\",\n                                                                                    \"ug_new_cvr\"\n                                                                                ],\n                                                                                start_time: rangeTime[0],\n                                                                                end_time: rangeTime[1],\n                                                                                period: \"daily\",\n                                                                                is_confirm: is_confirm\n                                                                            };\n                                                                        }"
                                  },
                                  "children": [
                                    {
                                      "name": "KeyMetricsCo",
                                      "className": "dbd-daily-card",
                                      "type": "view",
                                      "props": {
                                        "config": {
                                          "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                                          "haveJump": true,
                                          "loadingHeight": 570,
                                          "mainMetricsList": [
                                            "iaa_revenue",
                                            "ecpm",
                                            "arpu",
                                            "active_users",
                                            "d2t1",
                                            "d7t6",
                                            "fraud_active_users_rate",
                                            "spend",
                                            "new_users",
                                            "cpi",
                                            "af_cpi",
                                            "roas1",
                                            "ug_cost_ecpm",
                                            "ug_ctr"
                                          ],
                                          "metricsList": [
                                            "iaa_revenue",
                                            "ecpm",
                                            "arpu",
                                            "active_users",
                                            "d2t1",
                                            "d7t6",
                                            "fraud_active_users_rate",
                                            "spend",
                                            "new_users",
                                            "cpi",
                                            "af_cpi",
                                            "roas1",
                                            "ug_cost_ecpm",
                                            "ug_ctr"
                                          ],
                                          "formatRules": [
                                            {
                                              "keys": [
                                                "trend_list.metrics.arpu.value",
                                                "trend_list.metrics.arpu.last_value"
                                              ],
                                              "format": "twoDecimal"
                                            }
                                          ]
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "CommonRow",
                                          "children": [
                                            {
                                              "name": "CommonCol",
                                              "className": "dbd-daily-casual-card-wrap",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "IAARevenueMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "jumpUrl": "none",
                                                        "haveTrendChart": false,
                                                        "gradientStartColor": "#009DFF",
                                                        "gradientEndColor": "#1BBFF5",
                                                        "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "CasualMultiViewDimensionCard",
                                                  "height": 142,
                                                  "config": {
                                                    "props": {
                                                      "height": 150,
                                                      "changeHeight": 141
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "ecpmMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "isLeftCard": true,
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "arpuMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "jumpUrl": "none",
                                                        "isLeftCard": true,
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "className": "dbd-daily-casual-card-wrap",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "ActiveUsersMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "jumpUrl": "none",
                                                        "haveTrendChart": false,
                                                        "gradientStartColor": "#8675ff",
                                                        "gradientEndColor": "#a594ff",
                                                        "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "d2t1MetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "d7t6MetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "FakeDAURateMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "jumpUrl": "none",
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            },
                                            {
                                              "name": "CommonCol",
                                              "className": "dbd-daily-casual-card-wrap",
                                              "type": "layout",
                                              "style": {},
                                              "props": {
                                                "w": 8
                                              },
                                              "children": [
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "spendMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "isRightCard": true,
                                                        "jumpUrl": "none",
                                                        "haveTrendChart": false,
                                                        "gradientStartColor": "#5086F3",
                                                        "gradientEndColor": "#84ADFF",
                                                        "className": "dbd-daily-metric-card-flat-start dbd-daily-casual-color-card dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "NewUsersMetricCard",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "style": {
                                                        "minHeight": "232px"
                                                      },
                                                      "config": {
                                                        "jumpUrl": "none",
                                                        "isShowIcon": false,
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                      }
                                                    }
                                                  }
                                                },
                                                {
                                                  "name": "CommonRow",
                                                  "style": {
                                                    "marginTop": "-10px"
                                                  },
                                                  "children": [
                                                    {
                                                      "name": "CommonCol",
                                                      "className": "dbd-daily-casual-card-wrap-flex-none-pad-right",
                                                      "children": [
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/daily",
                                                          "componentKey": "cpiMetricCard",
                                                          "height": 160,
                                                          "config": {
                                                            "props": {
                                                              "config": {
                                                                "style": {
                                                                  "minHeight": "135px"
                                                                },
                                                                "jumpUrl": "none",
                                                                "isShowIcon": false,
                                                                "haveTrendChart": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat",
                                                                "subMetricConfig": {
                                                                  "metricKey": "af_cpi",
                                                                  "enName": "{{metricsInfo.af_cpi.en}}",
                                                                  "cnName": "{{metricsInfo.af_cpi.cn}}",
                                                                  "explainEn": "{{metricsInfo.af_cpi.explainEn}}",
                                                                  "explainCn": "{{metricsInfo.af_cpi.explainCn}}",
                                                                  "formatRule": "{{metricsInfo.af_cpi.formatter}}"
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    },
                                                    {
                                                      "name": "CommonCol",
                                                      "className": "dbd-daily-casual-card-wrap-flex-none-pad-left",
                                                      "children": [
                                                        {
                                                          "name": "MetricComponent",
                                                          "path": "overview/daily",
                                                          "componentKey": "roas1MetricCard",
                                                          "height": 160,
                                                          "config": {
                                                            "props": {
                                                              "config": {
                                                                "style": {
                                                                  "minHeight": "135px"
                                                                },
                                                                "jumpUrl": "none",
                                                                "isShowIcon": false,
                                                                "haveTrendChart": false,
                                                                "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat"
                                                              }
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                },
                                                {
                                                  "name": "MetricComponent",
                                                  "path": "overview/daily",
                                                  "componentKey": "CasualSimpleMetricGrid",
                                                  "height": 160,
                                                  "config": {
                                                    "props": {
                                                      "config": {
                                                        "className": "dbd-daily-metric-card-body-padded dbd-daily-metric-card-flat-end"
                                                      }
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "EventService",
                  "className": "",
                  "type": "view",
                  "style": {
                    "marginTop": "10px"
                  },
                  "props": {
                    "removeEventNumLimit": true
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "OverviewMetricsTrendCo",
                              "height": 467,
                              "data": {
                                "trendMetrics": [
                                  "active_users",
                                  "new_users",
                                  "d2",
                                  "d3",
                                  "d7",
                                  "d14",
                                  "d30",
                                  "total_users",
                                  "avg_active_user_matches",
                                  "avg_new_user_matches",
                                  "aot",
                                  "new_aot",
                                  "weighted_d2",
                                  "weighted_d3",
                                  "weighted_d7"
                                ]
                              },
                              "config": {
                                "props": {
                                  "config": {
                                    "enableFullScreen": true,
                                    "eventTypeMaxCount": 3,
                                    "fullScreenEnhancements": {
                                      "showEventFilter": true,
                                      "showEventWindows": true,
                                      "showSegmentTabsInFullScreen": true,
                                      "excludeEventTypes": [
                                        "Holiday"
                                      ],
                                      "persistEventSetting": true,
                                      "eventBubbleDetailsNav": {
                                        "minCountExclusive": 0,
                                        "path": "eventAnalysis/eventDetails",
                                        "query": {
                                          "timeType": "Day",
                                          "dashboardType": "overview"
                                        }
                                      },
                                      "eventTypeBarColorMap": {
                                        "版更": {
                                          "tagStyleAliases": [
                                            "Version"
                                          ],
                                          "eventTooltips": "#F19E55"
                                        },
                                        "Version": {
                                          "eventTooltips": "#F19E55"
                                        },
                                        "玩法": {
                                          "tagStyleAliases": [
                                            "Gameplay"
                                          ],
                                          "eventTooltips": "#1DB440"
                                        },
                                        "实验": {
                                          "tagStyleAliases": [
                                            "Experiment",
                                            "A/B Test",
                                            "AB Test",
                                            "ABTest"
                                          ],
                                          "eventTooltips": "#6E7794"
                                        }
                                      }
                                    },
                                    "renderIndex": 0,
                                    "showVs": false,
                                    "custom_accumulation": [
                                      "ua_network",
                                      "version"
                                    ],
                                    "metricLookbackDaysMap": {
                                      "d14": {
                                        "day": 30
                                      },
                                      "d30": {
                                        "day": 60
                                      }
                                    },
                                    "api": {
                                      "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                                      "extraParams": {
                                        "logical_flag": "show_7day_avg"
                                      }
                                    },
                                    "extraMetrics": [
                                      {
                                        "key": "last_avg_value",
                                        "nameEn": "7-day average",
                                        "nameCn": "7天平均值",
                                        "selected": true,
                                        "dateRangeConfig": {
                                          "days": 7,
                                          "periodType": "day"
                                        }
                                      }
                                    ],
                                    "eventTypesDisplayLast": [
                                      "Holiday"
                                    ]
                                  }
                                }
                              }
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "OverviewMetricsTrendCo",
                              "height": 467,
                              "data": {
                                "trendMetrics": [
                                  "iaa_revenue",
                                  "register_arpu",
                                  "arpu",
                                  "ecpm",
                                  "ctr",
                                  "spend",
                                  "cpi",
                                  "af_cpi",
                                  "ug_ctr",
                                  "iaa_impressions",
                                  "imps_per_dau",
                                  "iaa_viewers",
                                  "imps_per_viewers",
                                  "roas1",
                                  "roas7",
                                  "roas14",
                                  "roas30",
                                  "roas60",
                                  "roas90",
                                  "roas120",
                                  "roas180"
                                ]
                              },
                              "config": {
                                "props": {
                                  "config": {
                                    "enableFullScreen": true,
                                    "eventTypeMaxCount": 3,
                                    "fullScreenEnhancements": {
                                      "showEventFilter": true,
                                      "showEventWindows": true,
                                      "showSegmentTabsInFullScreen": true,
                                      "excludeEventTypes": [
                                        "Holiday"
                                      ],
                                      "persistEventSetting": true,
                                      "eventBubbleDetailsNav": {
                                        "minCountExclusive": 0,
                                        "path": "eventAnalysis/eventDetails",
                                        "query": {
                                          "timeType": "Day",
                                          "dashboardType": "overview"
                                        }
                                      },
                                      "eventTypeBarColorMap": {
                                        "版更": {
                                          "tagStyleAliases": [
                                            "Version"
                                          ],
                                          "eventTooltips": "#F19E55"
                                        },
                                        "Version": {
                                          "eventTooltips": "#F19E55"
                                        },
                                        "玩法": {
                                          "tagStyleAliases": [
                                            "Gameplay"
                                          ],
                                          "eventTooltips": "#1DB440"
                                        },
                                        "实验": {
                                          "tagStyleAliases": [
                                            "Experiment",
                                            "A/B Test",
                                            "AB Test",
                                            "ABTest"
                                          ],
                                          "eventTooltips": "#6E7794"
                                        }
                                      }
                                    },
                                    "renderIndex": 1,
                                    "showVs": false,
                                    "custom_accumulation": [
                                      "ua_network",
                                      "version"
                                    ],
                                    "metricLookbackDaysMap": {
                                      "roas7": {
                                        "day": 14
                                      },
                                      "roas14": {
                                        "day": 30
                                      },
                                      "roas30": {
                                        "day": 60
                                      },
                                      "roas60": {
                                        "day": 120
                                      },
                                      "roas90": {
                                        "day": 180
                                      },
                                      "roas120": {
                                        "day": 240
                                      },
                                      "roas180": {
                                        "day": 360
                                      }
                                    },
                                    "api": {
                                      "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                      "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                                      "extraParams": {
                                        "logical_flag": "show_7day_avg"
                                      }
                                    },
                                    "extraMetrics": [
                                      {
                                        "key": "last_avg_value",
                                        "nameEn": "7-day average",
                                        "nameCn": "7天平均值",
                                        "selected": true,
                                        "dateRangeConfig": {
                                          "days": 7,
                                          "periodType": "day"
                                        }
                                      }
                                    ],
                                    "eventTypesDisplayLast": [
                                      "Holiday"
                                    ],
                                    "formatRules": [
                                      {
                                        "keys": [
                                          "metrics.register_arpu.value",
                                          "metrics.register_arpu.last_value",
                                          "metrics.register_arpu.last_avg_value"
                                        ],
                                        "format": "twoDecimal"
                                      },
                                      {
                                        "keys": [
                                          "metrics.arpu.value",
                                          "metrics.arpu.last_value",
                                          "metrics.arpu.last_avg_value"
                                        ],
                                        "format": "twoDecimal"
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "MetricComponent",
                  "path": "overview/daily",
                  "componentKey": "OverviewTableCo",
                  "height": 775,
                  "data": {
                    "tableMetric": [
                      "total_users",
                      "new_users",
                      "active_users",
                      "iaa_revenue",
                      "ecpm",
                      "cpi",
                      "ug_install",
                      "af_cpi",
                      "new_ch_organic_rate",
                      "fraud_active_users_rate",
                      "spend",
                      "roi",
                      "register_arpu",
                      "arpu",
                      "d2",
                      "d3",
                      "d4",
                      "d5",
                      "d6",
                      "d7",
                      "d14",
                      "d30",
                      "roas1",
                      "roas2",
                      "roas3",
                      "roas7",
                      "roas14",
                      "roas30",
                      "roas60",
                      "roas90",
                      "roas120",
                      "roas180",
                      "iaa_impressions",
                      "avg_active_user_matches",
                      "avg_new_user_matches",
                      "aot",
                      "new_aot",
                      "retention_users",
                      "churn_users",
                      "churn_rate",
                      "return_users",
                      "weighted_d2",
                      "weighted_d3",
                      "weighted_d7",
                      "first_login_ratio",
                      "second_login_ratio"
                    ]
                  }
                },
                {
                  "name": "CommonRow",
                  "type": "layout",
                  "className": "margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                              "hasByType": false,
                              "extraParams": {
                                "metrics": [
                                  "roas1",
                                  "roas3",
                                  "roas7",
                                  "roas14"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "RoasMetricsUserCompositionCo",
                              "height": 366,
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "lineChart",
                                      "sheet"
                                    ],
                                    "initChartIndex": 1
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                              "hasByType": false,
                              "extraParams": {
                                "metrics": [
                                  "register_arpu",
                                  "cpi"
                                ]
                              },
                              "formatRules": [
                                {
                                  "keys": [
                                    "metrics.register_arpu.value"
                                  ],
                                  "format": "twoDecimal"
                                }
                              ]
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "NewUsersArpuCpiMetricsUserCompositionCo",
                              "height": 366,
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "lineChart",
                                      "sheet"
                                    ],
                                    "initChartIndex": 1
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                              "hasByType": false,
                              "extraParams": "function(data) {\n                                                                var segmentValue = (data === null || data === void 0 ? void 0 : data.segmentValue) || 'retention_d2_d3_d7';\n                                                                if (segmentValue === 'retention_d14') {\n                                                                    return {\n                                                                        metrics: [\n                                                                            'd14'\n                                                                        ]\n                                                                    };\n                                                                }\n                                                                if (segmentValue === 'retention_d30') {\n                                                                    return {\n                                                                        metrics: [\n                                                                            'd30'\n                                                                        ]\n                                                                    };\n                                                                }\n                                                                return {\n                                                                    metrics: [\n                                                                        'd2',\n                                                                        'd3',\n                                                                        'd7'\n                                                                    ]\n                                                                };\n                                                            }",
                              "segmentLookbackDaysMap": {
                                "retention_d14": {
                                  "day": 30
                                },
                                "retention_d30": {
                                  "day": 60
                                }
                              }
                            }
                          },
                          "data": {
                            "segmentValue": "retention_d2_d3_d7"
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "RetentionMetricsUserCompositionCo",
                              "height": 366,
                              "style": {
                                "height": 366
                              },
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "lineChart",
                                      "sheet"
                                    ],
                                    "initChartIndex": 1,
                                    "chartHeight": 214,
                                    "tableScrollHeight": 171,
                                    "segmentDataKey": "segmentValue",
                                    "multiMetricsMap": {
                                      "retention_d2_d3_d7": [
                                        {
                                          "key": "d2",
                                          "yAxisFormatter": "percentInt",
                                          "showLabel": true
                                        },
                                        {
                                          "key": "d3",
                                          "yAxisFormatter": "percentInt"
                                        },
                                        {
                                          "key": "d7",
                                          "yAxisFormatter": "percentInt"
                                        }
                                      ],
                                      "retention_d14": [
                                        {
                                          "key": "d14",
                                          "yAxisFormatter": "percentInt",
                                          "showLabel": true
                                        }
                                      ],
                                      "retention_d30": [
                                        {
                                          "key": "d30",
                                          "yAxisFormatter": "percentInt",
                                          "showLabel": true
                                        }
                                      ]
                                    },
                                    "componentSegment": [
                                      {
                                        "enName": "D2/D3/D7",
                                        "cnName": "D2/D3/D7",
                                        "value": "retention_d2_d3_d7"
                                      },
                                      {
                                        "enName": "D14",
                                        "cnName": "D14",
                                        "value": "retention_d14"
                                      },
                                      {
                                        "enName": "D30",
                                        "cnName": "D30",
                                        "value": "retention_d30"
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                              "hasByType": false,
                              "extraParams": {
                                "metrics": [
                                  "fraud_active_users_rate",
                                  "fraud_active_users"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "FakeDAUMetricsUserCompositionCo",
                              "height": 366,
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "barChart",
                                      "sheet"
                                    ],
                                    "initChartIndex": 1
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend",
                              "hasByType": false,
                              "extraParams": "function(data) {\n                                                                var segmentValue = (data === null || data === void 0 ? void 0 : data.segmentValue) || 'network_type';\n                                                                if (segmentValue === 'network_type') {\n                                                                    return {\n                                                                        metric: 'new_users',\n                                                                        logical_flag: 'show_all_data',\n                                                                        accumulation: {\n                                                                            custom_accumulation: [\n                                                                                {\n                                                                                    key: 'network_type',\n                                                                                    is_accumulation: true\n                                                                                }\n                                                                            ]\n                                                                        }\n                                                                    };\n                                                                }\n                                                                // ua_network 模式\n                                                                return {\n                                                                    metric: 'new_users',\n                                                                    logical_flag: 'show_all_data',\n                                                                    accumulation: {\n                                                                        custom_accumulation: [\n                                                                            {\n                                                                                key: 'ua_network',\n                                                                                is_accumulation: true\n                                                                            }\n                                                                        ]\n                                                                    }\n                                                                };\n                                                            }",
                              "formatData": "function(data, extraData) {\n                                                                if (!data) return;\n                                                                var grouped = {};\n                                                                data.forEach(function(item) {\n                                                                    var date = item.date;\n                                                                    var network = item.custom_dimensions && item.custom_dimensions[0] && item.custom_dimensions[0].value;\n                                                                    var newUsers = item.metrics && item.metrics.new_users && item.metrics.new_users.value;\n                                                                    if (!date || !network) return;\n                                                                    if (!grouped[date]) {\n                                                                        grouped[date] = {\n                                                                            date: date,\n                                                                            metrics: {}\n                                                                        };\n                                                                    }\n                                                                    grouped[date].metrics[network] = {\n                                                                        value: newUsers || '',\n                                                                        last_value: '',\n                                                                        last_avg_value: '',\n                                                                        last_month_value: '',\n                                                                        last_year_value: ''\n                                                                    };\n                                                                });\n                                                                var result = Object.values(grouped).sort(function(a, b) {\n                                                                    return a.date.localeCompare(b.date);\n                                                                });\n                                                                return result;\n                                                            }"
                            }
                          },
                          "data": {
                            "key": "network_type",
                            "segmentValue": "network_type"
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "NewUserBreakdownMetricsUserCompositionCo",
                              "height": 366,
                              "style": {
                                "height": 366
                              },
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "barChart",
                                      "stackLine",
                                      "sheet"
                                    ],
                                    "initChartIndex": 2,
                                    "showSum": true
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "UserCompositionCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                              "hasByType": false,
                              "extraParams": {
                                "metrics": [
                                  "spend",
                                  "iaa_revenue",
                                  "roi"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "overview/daily",
                              "componentKey": "SpendIaaRevenueRoiMetricsUserCompositionCo",
                              "height": 366,
                              "config": {
                                "props": {
                                  "config": {
                                    "showComList": [
                                      "eyes",
                                      "lineChart",
                                      "sheet"
                                    ],
                                    "initChartIndex": 1
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "type": "layout",
                  "style": {
                    "marginTop": 0
                  },
                  "props": {},
                  "children": [
                    {
                      "name": "RankListTabCo",
                      "className": "",
                      "style": {},
                      "type": "view",
                      "data": {
                        "regionDataType": "country",
                        "tabOrder": [
                          "country",
                          "region",
                          "os",
                          "ua_network",
                          "version"
                        ],
                        "tabMsg": {
                          "os": {
                            "aliasNameEn": "Platform",
                            "aliasNameCn": "平台"
                          },
                          "country": {
                            "aliasNameEn": "Countries",
                            "aliasNameCn": "国家"
                          },
                          "region": {
                            "aliasNameEn": "Regions",
                            "aliasNameCn": "区域"
                          },
                          "ua_network": {
                            "aliasNameEn": "Media Channels",
                            "aliasNameCn": "买量渠道"
                          },
                          "version": {
                            "aliasNameEn": "Versions",
                            "aliasNameCn": "版本"
                          }
                        },
                        "optionsInit": [
                          {
                            "value": "ua_network",
                            "textEn": "Media Channel",
                            "textCn": "买量渠道"
                          },
                          {
                            "value": "version",
                            "textEn": "Version",
                            "textCn": "版本"
                          }
                        ]
                      },
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "overview/daily",
                          "componentKey": "NewUsersMetricsRankListCo",
                          "height": 533,
                          "config": {
                            "props": {
                              "config": {
                                "jumpUrl": "none",
                                "comConfig": {
                                  "isHaveStackLine": true,
                                  "isHaveLine": false
                                },
                                "api": "/api/v1/dashboard/pc/overview_daily/breakdown",
                                "defaultChartType": "stackLine"
                              }
                            }
                          }
                        },
                        {
                          "name": "MetricComponent",
                          "path": "overview/daily",
                          "componentKey": "ActiveUsersMetricsRankListCo",
                          "height": 533,
                          "config": {
                            "props": {
                              "config": {
                                "jumpUrl": "none",
                                "defaultChartType": "map",
                                "api": "/api/v1/dashboard/pc/overview_daily/breakdown"
                              }
                            }
                          }
                        },
                        {
                          "name": "MetricComponent",
                          "path": "overview/daily",
                          "componentKey": "IaaRevenueMetricsRankListCo",
                          "height": 533,
                          "config": {
                            "props": {
                              "config": {
                                "jumpUrl": "none",
                                "api": "/api/v1/dashboard/pc/overview_daily/breakdown"
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) {\n                var unifiedid = data.unifiedid;\n                return '/intelligence/topCharts/mobileGames/gamesDetails/' + unifiedid;\n            }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview/KeyMetrics",
      "params": {
        "gameid": "unifiedid"
      },
      "permission": "hasOpinionPermissions"
    }
  ]
};
